import React, { Component } from 'react';
import 'antd/lib/dropdown/style/css';
import 'antd/lib/tooltip/style/css';
import preval from 'preval.macro';
import moment from 'moment';
import './ds.scss';
import Loading from './components/loading/loading';
import dict from './dictionary';
import trans from './translations.json';
import { currLang, currPage } from './components/utils';
import Genpop from './Genpop';
//will implement from lazy loading after
// import Solgen from './components/solgen/solgenIndex';
// import Education from './components/education/educationIndex';
// import Childcare from './components/childcare/childcareIndex';
import LTC from './components/LTC/ltcIndex';
// import LTCMap from './components/LTC/ltcMapPage';

// import Home from './components/home/home';
// import Summary from './components/summary/summaryIndex';
// import Shelters from './components/sheltersFacilitiesGroupHomes/shelters';
// import GroupHomes from './components/sheltersFacilitiesGroupHomes/groupHomes';
// import YouthFacilities from './components/sheltersFacilitiesGroupHomes/youthFacilities';
import DownloadMenuTranslate from './components/downloadMenuTranslate/downloadMenuTranslate';
import Ltc2 from './components/pages/ltc2';
import Hospitals from './components/pages/hospitals';
import Tests from './components/pages/tests';
import Sources from './components/pages/sources';
import All from './components/pages/all';

moment.updateLocale('en', {
  meridiem(hour, minute, isLowerCase) {
    return hour < 12 ? 'a.m.' : 'p.m.';
  },
});

class App extends Component {
  state = { loaded: false };

  componentDidMount() {
    this.display();
  }

  display = () => {
    this.setState({
      loaded: true,
      lang: currLang(),
      page: currPage(),
    });
  };

  handleLangToggle = () => {
    this.setState({
      lang: this.state.lang === 'en' ? 'fr' : 'en',
    });
  };

  render() {
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;
    const LastUpdated = (momentBuildTime) => (
      <p>
        <strong>{trans.overview.lastupdate[this.state.lang]}</strong>{' '}
        {momentBuildTime
          .utcOffset('-05:00')
          .format(
            lang === 'en'
              ? 'MMMM D, YYYY [at] hh:mm a'
              : 'D MMMM YYYY [à] hh [h] mm[.]',
          )}
        {/*  6 mai 2020 à 10 h 30. */}
        {/* May 6, 2020 at 10:30 a.m. */}
      </p>
    );

    const lang = this.state.lang;
    const buildTime = preval`process.env.TZ = 'America/Toronto'; module.exports = new Date();`;
    let momentBuildTime = moment(buildTime);

    const CurrentPage = () => {
      switch (this.state.page) {
        // case dict.pages.LTC:
        //   return (
        //     <LTC
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        case dict.pages.LTC2:
          return (
            <Ltc2
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );
        // case dict.pages.LTCMAP:
        //   return (
        //     <LTCMap
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        case dict.pages.HOSPITALS:
          return (
            <Hospitals
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );
        case dict.pages.TESTS:
          return (
            <Tests
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );

        case dict.pages.SOURCES:
          return (
            <Sources
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );
        case dict.pages.ALL:
          return (
            <All
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );
        // case dict.pages.SOLGEN:
        //   return (
        //     <Solgen
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.SCHOOLS:
        //   return (
        //     <Education
        //       type="schools"
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.CHILDCARE:
        //   return (
        //     <Childcare
        //       type="childcare"
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.HOME:
        //   return <Home lang={lang} />;
        // case dict.pages.SHELTERS:
        //   return (
        //     <Shelters
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.GROUPHOMES:
        //   return (
        //     <GroupHomes
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.YOUTHFACILITIES:
        //   return (
        //     <YouthFacilities
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //     />
        //   );
        // case dict.pages.SUMMARY:
        //   return (
        //     <Summary
        //       lang={lang}
        //       momentBuildTime={LastUpdated(momentBuildTime)}
        //       lastUpdated={momentBuildTime}
        //     />
        //   );
        default:
          return (
            <Genpop
              lang={lang}
              momentBuildTime={LastUpdated(momentBuildTime)}
            />
          );
      }
    };

    return (
      <div id="ontario-covid-viz">
        {this.state.loaded ? (
          <>
            <CurrentPage />
            <DownloadMenuTranslate lang={lang} />
          </>
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

export default App;
